import { render, staticRenderFns } from "./AccessControl.vue?vue&type=template&id=d1df3772&scoped=true"
import script from "./AccessControl.vue?vue&type=script&lang=js"
export * from "./AccessControl.vue?vue&type=script&lang=js"
import style0 from "./AccessControl.vue?vue&type=style&index=0&id=d1df3772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1df3772",
  null
  
)

export default component.exports